import Plyr from 'plyr'

import view from '@/mixins/view'

import Cover from '@/components/cover'

export default {
  name: 'not-found',
  mixins: [view],
  components: {
    Cover
  },
  data () {
    return {
      page: null,
      videoUrl: require('@/assets/videos/not-found.mp4')
    }
  },
  mounted () {
    this.ready = true

    const player = new Plyr(this.$refs['video'], {
      muted: true,
      autoplay: true,
      loop: { active: true }
    })
  },
  methods: {
    setMeta () {
      document.title = `404 | Hands`
    }
  }
}
